import React, { useContext } from 'react';
import {
	IVideosAssignmentContext,
	VideosAssignmentContext,
} from '../../../../../videosAssignmentState/videosAssignmentContext';
import SearchField from 'components/SearchField/SearchField';
import style from './Search.module.scss';

const Search: React.FC = () => {
	const { changeSearchString, searchString } = useContext<IVideosAssignmentContext>(VideosAssignmentContext);

	return (
		<div className={style.container}>
			<SearchField onChangeSelectSearchString={changeSearchString} searchString={searchString} delay={800} />
		</div>
	);
};

export default Search;
